import { iconsAsset } from "../../environment/icons/iconExport";

export const AssetTypes = {
  KeyPeople: "Key People",
  InternalApplication: "Internal Application",
  ExternalApplication: "External Application",
  SensitiveData: "Sensitive Data",
  Other: "Other",
};
export const AssetTypeInfo = {
  [AssetTypes.KeyPeople]: {
    title: "Key People",
    icon: iconsAsset[AssetTypes.KeyPeople],
  },
  [AssetTypes.InternalApplication]: {
    title: "Internal Application",
    icon: iconsAsset[AssetTypes.InternalApplication],
  },
  [AssetTypes.ExternalApplication]: {
    title: "External Application",
    icon: iconsAsset[AssetTypes.ExternalApplication],
  },
  [AssetTypes.SensitiveData]: {
    title: "Sensitive Data",
    icon: iconsAsset[AssetTypes.SensitiveData],
  },
  [AssetTypes.Other]: {
    title: "Other",
    icon: iconsAsset[AssetTypes.Other],
  },
};
